import React from 'react'
import CarouselSection from './CarouselSection/CarouselSection'
import OurProduct from './OurProduct/OurProduct'
import OurBranch from './OurBranch/OurBranch'
import PeopleSay from './WhatPeopleSay/PeopleSay'
import { BookSlot } from '../RegistrationForm/BookSlot'
import Footer from '../Component/Footer'


const Homepage = () => {
  return (
    <div>
      <CarouselSection/>
      <OurProduct/>
      <OurBranch/>
      <PeopleSay/>
      <BookSlot/>
      <Footer/>
    </div>
  )
}

export default Homepage
